import React, { createContext, useContext, useState } from 'react';

interface StaffStatusContextType {
  missingClockins: number;
  setMissingClockins: (count: number) => void;
  missingCheckins: number;
  setMissingCheckins: (count: number) => void;
}

const StaffStatusContext = createContext<StaffStatusContextType>({
  missingClockins: 0,
  setMissingClockins: () => {},
  missingCheckins: 0,
  setMissingCheckins: () => {},
});

export const StaffStatusProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [missingClockins, setMissingClockins] = useState<number>(0);
  const [missingCheckins, setMissingCheckins] = useState<number>(0);

  return (
    <StaffStatusContext.Provider value={{
      missingClockins,
      setMissingClockins,
      missingCheckins,
      setMissingCheckins,
    }}>
      {children}
    </StaffStatusContext.Provider>
  );
};

export const useStaffStatus = () => useContext(StaffStatusContext);

export default StaffStatusContext;